/* eslint-disable no-console */
import { Mutation, Action } from 'vuex-module-decorators';
import { Resolve } from 'vue-di';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import { JanssenGECheckRequestModel, ScriptsTempJanssenGECheckPatient } from '@trialcard/apigateway.models';
import { EdgePlpApi, EdgeTempApi } from '@trialcard/apigateway.client';
import { Settings } from '~/services/settings';
import EligibilityModule from '~/store/eligibility';
import SourceModule from '~/store/source';



@InjectModule({ stateFactory: true }, module)
export default class EnrollmentModule extends InjectVuexModule {

    @Resolve
    public plpApi!: EdgePlpApi;

    @Resolve
    public tempApi!: EdgeTempApi;

    @Resolve
    public settings!: Settings;

    @Resolve
    public eligibility!: EligibilityModule;

    @Resolve
    public source!: SourceModule;

    defaultMemberNumber = '';
    defaultUniqueId = '';
    defaultPatientInformationData = {
        firstName: '',
        lastName: '',
        gender: '',
        dateOfBirth: '',
        email: '',
        phoneNumbers: [
            {
                phoneNumberId: 0,
                countryCode: '1',
                areaCode: '',
                number: '',
                primaryPhoneNumber: true,
                phoneType: 0 // Cell
            }
        ],
        address1: '',
        address2: '',
        city: '',
        state: '',
        postalCode: '',
    };

    memberNumber = this.defaultMemberNumber;
    uniqueId = this.defaultUniqueId;
    patientInformationData = this.defaultPatientInformationData;

    @Mutation
    public setMemberNumber(memberNumber: string) {
        this.memberNumber = memberNumber;
    }

    @Mutation
    public updatePatientInformationData(patientInformationData: typeof EnrollmentModule.prototype.patientInformationData) {
        this.patientInformationData = patientInformationData;
    }

    @Mutation
    public setUniqueId(uniqueId: string) {
        this.uniqueId = uniqueId;
    }


    @Action({ rawError: true })
    public clearStore() {
        this.setMemberNumber(this.defaultMemberNumber);
        this.setUniqueId(this.defaultUniqueId);
        this.updatePatientInformationData(this.defaultPatientInformationData);
    }

    @Action({ rawError: true })
    public async checkForGe() {
        let isEligible = false;
        // let uniqueId = this.uniqueId
        const {
            firstName,
            lastName,
            gender,
            dateOfBirth,
            address1: addressLine1,
            city,
            state,
            postalCode: zipCode
        } = this.patientInformationData
        // if (!uniqueId) {
        //     uniqueId = uuidv4();
        //     this.setUniqueId(uniqueId);
        // }
        try {
            const request = {
                tcProgramId: +this.settings.tcProgramId,
                // uniqueId,
                patient: {
                    firstName,
                    lastName,
                    gender,
                    dateOfBirth,
                    addressLine1,
                    city,
                    state,
                    zipCode,
                } as ScriptsTempJanssenGECheckPatient
            } as JanssenGECheckRequestModel;

            const response = await this.tempApi.tempJanssenGeCheck(request);
            if (response?.data?.data?.isEligible) {
                isEligible = true;
            }
        } catch (error) {
            console.error('Error from GE check:', error);
        }
        return isEligible;
    }

    @Action({ rawError: true })
    async enrollPatient() {
        let isSuccessful = false;
        const request = {
            survey: [
                ...this.eligibility.eligibilityData
            ],
            clientIdentifiers: {
                sites: [],
                sourceId: this.source.id,
                // alternateId: this.uniqueId, // corresponds to the uniqueId we are passing for the GE check
                // alternateIdType: 'ThirdPartyID',
            },
            demographics: {
                ...this.patientInformationData,
                communicationTypes: [
                    0, // mail
                    // 2, // vmail
                    3, // phone
                    4, // email
                ],
                communicationOption: 1, // Opt-In,
                paymentType: 2, // Check to patient
            }
        };
        try {
            const response = await this.plpApi.enrollPatientExpressEnrollment(request, this.settings.tcProgramId)
            const memberNumber = response?.data?.data?.memberNumber;
            if (memberNumber) {
                isSuccessful = true;
                this.setMemberNumber(memberNumber);
            }
        } catch (error) {
            console.error('Error from patient enrollment:', error);
        }
        return isSuccessful;
    }

}
